module.exports = __webpack_public_path__ + "static/media/Emotes-Rough.00f4e8a4.png";